import { IMarketingCategory } from '@features/productPreview/typescript';
import { TDataLayer } from '@typescript/index';
import { getCurrencyByRegion, toISO4217CurrencyCode } from '@utils/formatPrice';
import { getRegion, getLanguage } from '@utils/misc';
import getPublicEnv from '@utils/getPublicEnv';
import { safeParsePrice } from '@utils/safePriceParser';
const GoogleTagManagerViewItem = (itemId: number, itemName: string, priceString: string, categories: Array<IMarketingCategory>, brand: string | undefined) => {
  const region = getRegion();
  const currency = toISO4217CurrencyCode(getCurrencyByRegion(region));
  const price = safeParsePrice(priceString, currency);
  if (price === 0 || isNaN(price) || !isFinite(price)) {
    console.warn(`GoogleTagManagerViewItem: Invalid price "${priceString}" for product ${itemId} (${itemName}). Skipping DataLayer event.`);
    return;
  }
  const currentLanguage = getLanguage(getPublicEnv('NEXT_PUBLIC_DEFAULT_LOCALE'));
  const item_collection = categories[0]?.[`name_${currentLanguage}`] ?? '';
  const item_list_name = categories[1] ? categories[1][`name_${currentLanguage}`] : item_collection;
  const item_category = categories[2] ? categories[2][`name_${currentLanguage}`] : item_list_name;
  const tagManagerArgs: TDataLayer = {
    event: 'view_item',
    ecommerce: {
      currency,
      value: price,
      items: [{
        item_collection,
        item_brand: brand,
        item_list_name,
        item_category,
        item_id: itemId,
        item_name: itemName,
        price
      }]
    }
  };
  if (window && window.dataLayer) {
    window.dataLayer.push({
      ecommerce: null
    });
    window.dataLayer.push(tagManagerArgs);
  }
};
export default GoogleTagManagerViewItem;